import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Solution1Component } from './solution1.component';

const routes: Routes = [
  {
    path: '',
    component: Solution1Component,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Solution1RoutingModule {
}
